import React, { useState, useEffect } from 'react'
import { Panel, Grid, Row, Col, Timeline, Icon, Progress, Steps, Drawer, Button } from 'rsuite'
import { doneLoading, startLoading } from '../../utils/loading'
import { getOverviewCurrentStatus } from '../../redux/actions/projectOverview'

export default function OverviewCurrentStatus({ projectVersionId }) {
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState()

  const [colSet1, setColSet1] = useState({ lg: 24, md: 24, sm: 24, xs: 24 })
  const [colSet2, setColSet2] = useState({ lg: 12, md: 12, sm: 24, xs: 24 })

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getOverviewCurrentStatus(projectVersionId)

      if (response?.forms?.valueRight?.length > 0) {
        setColSet1({ lg: 12, md: 12, sm: 24, xs: 24 })
      }

      setFormSchema(response?.forms || null)
    } catch (e) {
      console.log('OverviewCurrentStatus error => ', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  if (!formSchema) {
    return ''
  }

  if ((formSchema?.valueLeft ?? []).length === 0 && (formSchema?.valueRight ?? []).length === 0) {
    return ''
  }

  const stepComponents = (header, currentLeftStep, value) => {
    return (
      <>
        <Panel header={header ?? ''} collapsible defaultExpanded>
          <div style={{ maxHeight: 600, overflowY: 'auto', overflowX: 'hidden' }}>
            <Steps current={currentLeftStep} vertical>
              {value?.map((item, index) => {
                return (
                  <>
                    <Steps.Item
                      icon={
                        item.icon ? (
                          <Icon
                            icon={item.icon || undefined}
                            size="2x"
                            style={{ color: item.iconColor }}
                          />
                        ) : undefined
                      }
                      key={index}
                      title={<b>{item.title}</b>}
                      description={
                        <div style={{ position: 'absolute', marginTop: -10 }}>{item.desc}</div>
                      }
                      style={{ marginBottom: 5 }}
                    />
                  </>
                )
              })}
            </Steps>
          </div>
        </Panel>
      </>
    )
  }

  return (
    <>
      <Panel bordered shaded header={formSchema?.header?.header ?? ''} collapsible defaultExpanded>
        <Row>
          {Array.isArray(formSchema?.valueLeft) && formSchema?.valueLeft?.length > 0 && (
            <Col lg={colSet1.lg} md={colSet1.md} sm={colSet1.sm} xs={colSet1.xs}>
              {stepComponents(
                formSchema.header.subHeaderLeft,
                formSchema.header.currentLeftStep,
                formSchema.valueLeft
              )}
            </Col>
          )}

          {Array.isArray(formSchema?.valueRight) && formSchema?.valueRight?.length > 0 && (
            <Col lg={colSet2.lg} md={colSet2.md} sm={colSet2.sm} xs={colSet2.xs}>
              {stepComponents(
                formSchema.header.subHeaderRight,
                formSchema.header.currentRightStep,
                formSchema.valueRight
              )}
            </Col>
          )}
        </Row>
      </Panel>

      <br />
    </>
  )
}
